export default {
    props: {
      extras: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        isSaveVariants : false,
        selectedExtrasDefault : null,
        isOpenExtraVariantSelectPage: false,
        extraVariants: [],
        selectedExtras: [],
        portalBox: { top: 60, left: 0, width: 800, height: 600 },
      };
    },
    computed: {
      portalInlineStyle() {
        const b = this.portalBox;
        return {
          top: `${b.top}px`,
          left: `${b.left}px`,
          width: `${b.width}px`,
          height: `${b.height}px`,
        };
      },
    },
    watch: {
      isOpenExtraVariantSelectPage(val){
        if(val){
          this.selectedExtrasDefault = _.cloneDeep(this.selectedExtras);
          this.isSaveVariants = false;
        }else if(!val && !this.isSaveVariants){
          this.selectedExtras = this.selectedExtrasDefault;
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.updatePrimaryPortalBox();
        this._portalOnResize = () => this.updatePrimaryPortalBox();
        window.addEventListener("resize", this._portalOnResize);
        window.addEventListener("scroll", this._portalOnResize, true);
        const primary = document.querySelector(
          "#new-sale-screen .new-sale-screen-content .primary"
        );
        if (primary && typeof ResizeObserver !== "undefined") {
          this._portalResizeObserver = new ResizeObserver(() =>
            this.updatePrimaryPortalBox()
          );
          this._portalResizeObserver.observe(primary);
        }
      });
    },
    beforeDestroy() {
      if (this._portalOnResize) {
        window.removeEventListener("resize", this._portalOnResize);
        window.removeEventListener("scroll", this._portalOnResize, true);
      }
      if (this._portalResizeObserver) {
        this._portalResizeObserver.disconnect();
        this._portalResizeObserver = null;
      }
    },
    created: function () {
      this.selectedExtras = [];
      this.extras.forEach(item => {
        this.selectedExtras.push({
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: item.quantity ? item.quantity : 0,
          variants: item.variants != null && item.variants.length > 0 ? this
            .fillExtraVariants(item
              .variants) : null
        });
        this.selectedExtrasDefault = _.cloneDeep(this.selectedExtras);
      });
    },
    methods: {
      updatePrimaryPortalBox() {
        const w = typeof window !== "undefined" ? window.innerWidth : 1200;
        const hWin = typeof window !== "undefined" ? window.innerHeight : 800;
        /* Mobil: viewport genişliği + header altı — Brew benzeri tam sayfa */
        if (w <= 767) {
          const header = document.querySelector(
            "#new-sale-screen .new-sale-screen-header-container"
          );
          const topPx =
            header && typeof header.getBoundingClientRect === "function"
              ? header.getBoundingClientRect().bottom
              : 60;
          this.portalBox = {
            top: topPx,
            left: 0,
            width: w,
            height: Math.max(120, hWin - topPx),
          };
          return;
        }
        const primary = document.querySelector(
          "#new-sale-screen .new-sale-screen-content .primary"
        );
        if (!primary || typeof primary.getBoundingClientRect !== "function") {
          return;
        }
        const r = primary.getBoundingClientRect();
        this.portalBox = {
          top: r.top,
          left: r.left,
          width: r.width,
          height: r.height,
        };
      },
      saveExtraVariantSelection() {
        this.isSaveVariants = true;
        this.isOpenExtraVariantSelectPage = false;
      },
      cancelExtraVariantSelection() {
        this.selectedExtras = this.selectedExtrasDefault;
        this.isOpenExtraVariantSelectPage = false;
      },
      fillExtraVariants(variants) {
        let variantModel = [];
        variants.forEach(variant => {
          variantModel.push({
            id: variant.id,
            name: variant.name,
            price: variant.price,
            quantity: variant.quantity ? variant.quantity : 0,
          })
        });
        return variantModel;
      },
      closeVariantSelection() {

      },
      openExtraVariantSelectPage(extra) {
        this.isOpenExtraVariantSelectPage = true;
        this.extraVariants = extra.variants;
      },
      saveExtras: function () {
        let extraObj = [];
        this.selectedExtras.forEach(item => {
          let extra = {
            id: item.id,
            name: item.name,
            quantity: item.quantity,
            price: item.price,
            variants: []
          };
          if (item.variants != null && item.variants.length > 0) {
            item.variants.forEach(variant => {
              extra.variants.push({
                id: variant.id,
                name: variant.name,
                price: variant.price,
                quantity: variant.quantity
              });
            });
          }
          extraObj.push(extra);
        });
        this.$emit("saveExtras", extraObj);
      },
      cancelExtras: function () {
        this.$emit("cancelExtras");
      },
      /** Sepet satırıyla aynı: seçili varyantları "x2 | İsim" olarak listeler */
      returnSelectedExtraVariant(extra) {
        if (!extra || !extra.variants || !extra.variants.length) {
          return null;
        }
        const lines = extra.variants
          .filter((v) => v.quantity > 0)
          .map((v) => "x" + v.quantity + " | " + v.name);
        return lines.length > 0 ? lines : null;
      },
    }
  };